import { GridInputArray } from "../types"
import { collection, get, all, update } from "typesaurus"
import type { scoringType } from "../groupUAs"
import type { Set } from "../sets"

export interface UserAssessment {
  answersByItem?: { [key: string]: AnswersByItemType }
  assessmentSetId: string
  classIds: any
  classes: any
  school: string
  schoolDistrict: string
  scoring?: scoringType
  state: string
  teacherIds: any
  teachers: { [key: string]: boolean }
  timeRemaining: { [key: string]: number }
  userAssessmentId: string
  userId?: string
  year?: string
  [key: string]: any
}

export type GridInputsType = {
  gridInputs: Record<string, GridInputArray>
}

export type AnswersByItemType = {
  gridInputs?: GridInputsType
  responseVectors?: Record<string, boolean>
  thetas?: Record<string, number>
  [x: string]: any
}

export type sumDataType = {
  answersByItem: AnswersByItemType
  assessmentId: string
  assessmentSet: Set
  assessmentSubtests: {
    [key: string]: Set
  }
  destructuredSubtests: {
    [key: string]: {
      items: string[]
    }
  }
  district: string
  groupId: string
  groupType: string
  id: string
  lastUpdated: number
  scoring: scoringType
  state: string
  updated: boolean
  year: number
}

const collection_ref = collection<UserAssessment>("userAssessments")

export const getUserAssessmentById = (id: string) => {
  return get(collection_ref, id)
}

export const getAllUserAssessments = () => {
  return all(collection_ref)
}

export const updateUserAssessmentById = (
  id: string,
  newVals: Partial<UserAssessment>
) => {
  return update(collection_ref, id, newVals)
}
